import React from 'react';

import LocaleMessage from '~/components/LocaleMessage';

/** Rótulos dos atalhos de período do `ReportHeader` (dashboard e pluginspace). */
export function buildCleaningReportShortcutList() {
    return {
        today: <LocaleMessage msg="button.today" />,
        '30_days': <LocaleMessage msg="button.last_30_days" />,
        '60_days': <LocaleMessage msg="button.last_60_days" />,
        '90_days': <LocaleMessage msg="button.last_90_days" />,
        custom: <LocaleMessage msg="button.custom" />,
    };
}
